/// <amd-module name="Repos/Views/PullRequestListingPage/Components/PullRequestListingPageTab" />
import * as React from "react";
import { ReposMessages } from "Repos/Messages/Components/ReposMessages";
import { PullRequestsList } from "Repos/PullRequestList/Components/PullRequestsList";
import { IPullRequestSection } from "Repos/PullRequestList/Contracts";
import { getPullRequestDataProviderService } from "Repos/PullRequestList/PullRequestDataProviderService";
import * as Resources from "Repos/Views/PullRequestListingPage/Resources";
import { IReadyableReadonlyObservableArray, ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { IFilter } from "VSSUI/Utilities/Filter";
import { IPullRequestListingService, IPullRequestListingView } from "../PullRequestListingService";

export interface IPullRequestListingPageTabProps {
    filter: IFilter;
    onLoaded: () => void;
    selectedTabId: ObservableValue<string>;
}

export class PullRequestListingPageTab extends VssComponent<IPullRequestListingPageTabProps> {
    private view: IPullRequestListingView;

    constructor(props: IPullRequestListingPageTabProps, context: IVssComponentContext) {
        super(props, context);

        const pullRequestListingService = this.context.pageContext.getService<IPullRequestListingService>("IPullRequestListingService");
        this.view = pullRequestListingService.getPullRequestsView(this.props.selectedTabId, this.props.filter);
    }

    public render() {
        return (
            <div className="page-content page-content-top flex-column flex-grow rhythm-vertical-16">
                <ReposMessages className="flex-noshrink" />
                <Observer sections={this.view.sections}>
                    {({ sections }: { sections: IReadyableReadonlyObservableArray<IPullRequestSection> }) => {
                        return (
                            <PullRequestsList
                                onLoaded={this.props.onLoaded}
                                onToggleDecline={pr => getPullRequestDataProviderService(this.context.pageContext).toggleDeclineToReview(pr)}
                                onToggleFlagged={pr => getPullRequestDataProviderService(this.context.pageContext).toggleFlagged(pr)}
                                sections={sections}
                                zeroDataMessage={
                                    this.props.selectedTabId.value === "mine" ? Resources.EmptyPrListingPrimary : Resources.EmptyPrListingNoMatches
                                }
                            />
                        );
                    }}
                </Observer>
            </div>
        );
    }
}
